import { Pipe, PipeTransform } from '@angular/core';
import { TranslationService } from 'src/app/core/services/translation/translation.service';

@Pipe({
  name: 'lnrDate',
})
/**
 * Date pipe that uses locale to show pretty dates
 */
export class LnrDatePipe implements PipeTransform {
  /**
   * @constructor
   */
  constructor(private readonly translationService: TranslationService) {}

  /**
   * @param {Date} date
   * @return {string | null}
   */
  transform(date: Date): string | null {
    return this.translationService.localizeDate(date);
  }
}
